import React from 'react';
import Feature from '../feature/Feature';
import { InputText } from 'primereact/inputtext';
import { type paths } from '../../../../endpoint/Schema';
import { Icons } from '../../../../assets/icons';

interface IDClubFeatureProps {
  featureSettings:
    | paths['/api/v2/admin/feature-setting']['get']['responses']['200']['content']['application/json']
    | undefined;
  setFeatureSettings: React.Dispatch<
    React.SetStateAction<
      | paths['/api/v2/admin/feature-setting']['get']['responses']['200']['content']['application/json']
      | undefined
    >
  >;
}

export default function DClubFeature({
  featureSettings,
  setFeatureSettings,
}: IDClubFeatureProps) {
  function handleDClubChecked(checked: boolean) {
    setFeatureSettings((prev) => ({
      ...prev,
      dClubSettings: {
        ...prev?.dClubSettings,
        enabled: checked,
        clubName: featureSettings?.dClubSettings?.clubName ?? 'D-Club',
      },
    }));
  }
  return (
    <Feature
      icon={Icons.ic_dclub}
      image="img_dashboard"
      title="D-Club"
      description="With the D Club feature, users can engage in friendly competition with others while earning rewards for their achievements. Users have the opportunity to climb to the top of leaderboards and earn rewards for their performance. Additionally, users can invite others to join their club, fostering a sense of community and earning rewards for successful referrals."
      checked={featureSettings?.dClubSettings?.enabled ?? false}
      onChange={handleDClubChecked}
    >
      <div
        className={`flex flex-col p-5 mb-6 rounded-xl ${featureSettings?.dClubSettings?.enabled ? 'bg-g10 shadow-[0px_4px_12px_rgba(0,0,0,0.1)]' : 'bg-whiteSmoke mt-6'}`}
      >
        <div className="w-[40%] max-w-xl min-w-96">
          <div className="text-base mb-6">
            Do you plan to customize D-Club name?
            <br />
          </div>
          <div>Club name</div>
          <InputText
            value={featureSettings?.dClubSettings?.clubName}
            onChange={(e) => {
              setFeatureSettings((prev) => ({
                ...prev,
                dClubSettings: {
                  ...prev?.dClubSettings,
                  enabled: featureSettings?.dClubSettings?.enabled,
                  clubName: e.target.value,
                },
              }));
            }}
            className="mt-3 p-inputtext-lg w-full"
          />
        </div>
      </div>
    </Feature>
  );
}
